import { useState } from "react";
import { Download, X } from "lucide-react";
import DialogButton from "shared/buttons/DialogButton";
import { useAuth } from "features/auth/AuthContext";
import { getInstallPromptDismissedAt } from "features/auth/services/auth";
import { useInstallPrompt } from "shared/hooks/useInstallPrompt";
import InstallAppInstructionsDialog from "./InstallAppInstructionsDialog";

const InstallAppBanner = () => {
    const { userId } = useAuth();
    const { show, platform, dismiss } = useInstallPrompt(userId, getInstallPromptDismissedAt());
    const [dialogOpen, setDialogOpen] = useState(false);

    if (!show) return null;

    return (
        <>
            <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-4 sm:max-w-sm z-40">
                <div className="bg-white rounded-lg shadow-lg border-l-4 border-purple-500 p-4 flex items-start gap-3">
                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-purple-100 text-purple-600">
                        <Download className="h-4 w-4" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold text-gray-800 mb-1">Instale o app</p>
                        <p className="text-sm text-gray-600 mb-3">
                            Adicione o Bailarina Preparada App à tela inicial para acesso rápido, como um app de verdade.
                        </p>
                        <DialogButton onClick={() => setDialogOpen(true)} fullWidthOnMobile={false}>
                            Ver como instalar
                        </DialogButton>
                    </div>
                    <button
                        type="button"
                        onClick={dismiss}
                        aria-label="Fechar"
                        className="shrink-0 text-gray-400 hover:text-gray-600"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            </div>

            <InstallAppInstructionsDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                platform={platform}
            />
        </>
    );
};

export default InstallAppBanner;
